import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { Modal } from 'react-bootstrap';
import './Orders.scss'
import Table from '../Table/Table'

import moment from 'moment'
import 'moment/locale/es';
import swal from 'sweetalert';
import Loader from '../PageStates/Loader';
import Error from '../PageStates/Error';

function Orders() {
  const [pageState, setPageState] = useState(1)
  const [permission, setPermission] = useState(null)

  const [orders, setOrders] = useState([])
  const [orderCount, setOrderCount] = useState(0)

  const [searchInput, setSearchInput] = useState("")
  const [sortColumn, setSortColumn] = useState("")
  const [sortOrder, setSortOrder] = useState("")
  const [tablePage, setTablePage] = useState(1)
  const [data, setData] = useState([])
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");


  // Modal
  const [viewModalShow, setViewModalShow] = useState(false)
  const [viewOrderDetails, setViewOrderDetails] = useState(null)
  const [filterFrom, setFilterFrom] = useState(null);
  const [filterTo, setFilterTo] = useState(null);


  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDateFrom(today);
    setDateTo(today);
  }, []);

  useEffect(() => {
    moment.locale("es");
    fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/verifiy_token`, {
      method: 'POST',
      credentials: 'include'
    })
      .then(res => res.json())
      .then(body => {
        if (body.operation === 'success') {
          fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/get_permission`, {
            method: 'POST',
            credentials: 'include'
          })
            .then(res => res.json())
            .then(body => {
              const p = body.permissions?.find(x => x.page === 'orders');

              if (p?.view && p?.create) {
                setPermission(p);
              } else {
                window.location.href = '/unauthorized';
              }
            });
        } else {
          window.location.href = '/login';
        }
      })
      .catch(console.log);
  }, [])

  const getOrders = async (sv, sc, so, scv) => {
    let result = await fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/get_orders`, {
      method: 'POST',
      headers: { 'Content-type': 'application/json; charset=UTF-8' },
      body: JSON.stringify({
        start_value: sv,
        sort_column: sc,
        sort_order: so,
        search_value: scv,
        date_from: filterFrom,
        date_to: filterTo,

      }),

      credentials: 'include'
    })

    let body = await result.json()
    setOrders(body.info.orders)
    setOrderCount(body.info.count)
  }

  useEffect(() => {
    if (permission !== null) {
      getOrders((tablePage - 1) * 10, sortColumn, sortOrder, searchInput)
        .then(() => setPageState(2))
        .catch(() => setPageState(3));
    }
  }, [permission, tablePage, sortColumn, sortOrder, searchInput]);


  const deleteOrder = async (id) => {
    let result = await fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/delete_order`, {
      method: 'POST',
      headers: { 'Content-type': 'application/json; charset=UTF-8' },
      body: JSON.stringify({ order_id: id }),
      credentials: 'include'
    })

    let body = await result.json()
    if (body.operation === 'success') {
      getOrders((tablePage - 1) * 10, sortColumn, sortOrder, searchInput);
      swal('Éxito', body.message, 'success')
    } else {
      swal('Oops!', 'Algo salió mal', 'error')
    }
  }

  useEffect(() => {
    if (orders.length !== 0) {
      let tArray = orders.map((obj, i) => {
        let tObj = {}
        tObj.sl = i + 1;
        tObj.order_ref = obj.order_ref;
        tObj.customer_name = obj.customer_name;
        tObj.due_date = moment(obj.due_date).format('D [de] MMMM, YYYY');
        tObj.grand_total = obj.grand_total;
        tObj.addedon = moment(obj.timeStamp).format('D [de] MMMM, YYYY');
        tObj.action =
          <>
            <button className='btn warning' style={{ marginRight: '0.5rem' }} onClick={() => { viewModalInit(obj.order_id) }}>
              Ver
            </button>
            {
              permission.delete &&
              <button className='btn danger' style={{ marginLeft: '0.5rem' }}
                onClick={() => {
                  swal({
                    title: "¿Estás seguro?",
                    text: "Una vez eliminado, no podrás recuperar este pedido.",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                  })
                    .then((willDelete) => {
                      if (willDelete) deleteOrder(obj.order_id)
                    });
                }}
              >
                Eliminar
              </button>
            }
          </>
        return tObj;
      })
      setData(tArray)
    } else {
      setData([])
    }
  }, [orders])

  const viewModalInit = (id) => {
    let p = orders.find(x => x.order_id === id)
    setViewOrderDetails(p)
    setViewModalShow(true);
  }

  const handleViewModalClose = () => {
    setViewModalShow(false);
    setViewOrderDetails(null)
  }

  // ---------- IMPRESION (MISMO ESTILO QUE PROFORMAS) ----------
  const toNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const money = (n) => {
    const num = Number(n);
    if (!Number.isFinite(num)) return "0.00";
    return num.toFixed(2);
  };

  const imprimirVenta = (o) => {
    if (!o) return;

    let items = [];
    try {
      items = o.items ? JSON.parse(o.items) : [];
    } catch (e) {
      items = [];
    }

    const filas = (items || [])
      .map((it) => {
        const cant = toNumber(it.quantity);
        const pu = toNumber(it.rate);
        const det = String(it.product_name || "").replace(/\n/g, "<br/>");
        const tot = cant * pu;

        return `
          <tr>
            <td class="td-right" style="width:55px;">${cant}</td>
            <td class="td-left wrap">${det}</td>
            <td class="td-right" style="width:80px;">${money(pu)}</td>
            <td class="td-right" style="width:90px;">${money(tot)}</td>
          </tr>
        `;
      })
      .join("");

    const html = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>Venta ${o.order_ref || ""}</title>
  <style>
    @page { size: letter portrait; margin: 0; }
    body { margin: 0; font-family: Arial, sans-serif; color: #111; }
    .ticket { width: 8.5in; height: 5.5in; box-sizing: border-box; padding: 0.35in 0.45in; margin: 0 auto; overflow: hidden; }
    .wrap { word-break: break-word; overflow-wrap: anywhere; }
    .small { font-size: 11px; line-height: 1.25; }
    .muted { color: #444; }
    .title { font-size: 16px; font-weight: 700; letter-spacing: 0.5px; }
    .header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
    .col-left  { width: 33%; }
    .col-center{ width: 34%; text-align: center; }
    .col-right { width: 33%; text-align: right; }
    .logo { width: 170px; height: auto; display: block; margin-bottom: 6px; }
    hr { border: 0; border-top: 1px solid #ddd; margin: 10px 0; }
    .mid { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
    .mid-left { width: 55%; }
    .mid-right{ width: 45%; text-align: right; }
    table { width: 100%; border-collapse: collapse; margin-top: 6px; }
    thead th { font-size: 12px; text-align: left; border-bottom: 1px solid #ddd; padding: 7px 6px; }
    tbody td { font-size: 12px; border-bottom: 1px dashed #eee; padding: 7px 6px; vertical-align: top; }
    .td-right { text-align: right; }
    .td-left { text-align: left; }
    .totals { width: 260px; margin-left: auto; margin-top: 10px; }
    .totals table { width: 100%; }
    .totals td { font-size: 12px; padding: 4px 6px; }
    .totals tr td:first-child { text-align: left; }
    .totals tr td:last-child { text-align: right; font-weight: 700; }
  </style>
</head>
<body>
  <div class="ticket">
    <div class="header">
      <div class="col-left">
        <img class="logo" src="/tajima.png" alt="TAJIMA" />
        <div class="small">
          <div><b>BORDADOS COMPUTARIZADOS</b></div>
          <div>Y APLICACIONES TAJIMA TEXTIL</div>
          <div class="muted">E-mail: byatajima@gmail.com</div>
          <div class="muted">jhonnfya@hotmail.com</div>
        </div>
      </div>

      <div class="col-center">
        <div class="title">VENTA</div>
        <div class="small" style="margin-top:10px;">
          <div><b>Dir.:</b> Av. Juan Pablo II Ceja</div>
          <div>(El Alto lado Transito - Bolivia)</div>
          <div>Cel.: 75866135-75274747-77221750</div>
        </div>
      </div>

      <div class="col-right small" style="margin-top:14px;">
        <div>
  N°:
  <span style="font-size:20px; font-weight:800;">
    ${o.order_id || "--"}
  </span>
</div>

        <div>Fecha: <b>${moment(o.timeStamp).format("YYYY-MM-DD")}</b></div>
      </div>
    </div>

    <hr />

    <div class="mid small">
      <div class="mid-left wrap">
        <div><b>Cliente:</b> ${o.customer_name || ""}</div>
        <div><b>Fecha:</b> ${moment(o.due_date).format("YYYY-MM-DD")}</div>
        <div><b>Impuesto:</b> ${toNumber(o.tax)}%</div>
      </div>
      <div class="mid-right">
        <div class="muted"><b>Total:</b> ${money(o.grand_total)}</div>
      </div>
    </div>

    <hr />

    <table>
      <thead>
        <tr>
          <th style="width:55px;" class="td-right">Cant</th>
          <th class="td-left">Detalle</th>
          <th style="width:80px;" class="td-right">P/U</th>
          <th style="width:90px;" class="td-right">Total</th>
        </tr>
      </thead>
      <tbody>
        ${filas || `<tr><td colspan="4" style="padding:10px; font-size:12px;">(Sin ítems)</td></tr>`}
      </tbody>
    </table>

    <div class="totals">
      <table>
        <tr><td>Impuesto</td><td>${toNumber(o.tax)}%</td></tr>
        <tr><td>Total</td><td>${money(o.grand_total)}</td></tr>
      </table>
    </div>
  </div>

  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() { window.close(); };
    };
  </script>
</body>
</html>
    `;

    const w = window.open("", "_blank", "width=900,height=650");
    if (!w) {
      swal("Bloqueado", "Tu navegador bloqueó la ventana de impresión. Permite pop-ups.", "warning");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  //IMPRESION TERMICA

const imprimirVentaTermica = (o) => {
    if (!o) return;

   let items = [];
    try {
      items = o.items ? JSON.parse(o.items) : [];
    } catch (e) {
      items = [];
    }

    const safe = (s) =>
      String(s ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");


      const filas = (items || [])
      .map((it) => {
        const cant = toNumber(it.quantity);
        const pu = toNumber(it.rate);
        const det = String(it.product_name || "").replace(/\n/g, "<br/>");
        const tot = cant * pu;

        return `
          <tr>
            <td class="td-center" style="width:15px;">${cant}</td>
            <td class="td-left wrap">${det}</td>
            <td class="td-right" style="width:40px;">${money(pu)}</td>
            <td class="td-right" style="width:50px;">${money(tot)}</td>
          </tr>
        `;
      })
      .join("");

    const subtotal = items.reduce((acc, it) => acc + toNumber(it.quantity) * toNumber(it.rate), 0);

    const html = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>Venta ${safe(String(o.order_id ?? ""))}</title>
  <style>
    @page { size: 80mm auto; margin: 0; }
    * { box-sizing: border-box; }
    body {
      margin: 0;
      font-family: 'Lucida Console', Courier, monospace;
      font-size: 11px;
      color: #000;
      width: 80mm;
    }
    .ticket { width: 80mm; padding: 4mm 4mm 8mm 4mm; }
    .center { text-align: center; }
    .left   { text-align: left; }
    .right  { text-align: right; }
    .bold   { font-weight: 700; -webkit-text-stroke: 0.3px #000; text-shadow: 0.3px 0 0 #000; }
    .wrap   { word-break: break-word; overflow-wrap: anywhere; }
    .empresa-nombre { font-size: 13px; font-weight: 800; text-align: center; -webkit-text-stroke: 0.4px #000; text-shadow: 0.4px 0 0 #000; }
    .empresa-sub    { font-size: 10px; text-align: center; line-height: 1.3; }
    .sep-solid  { border: 0; border-top: 1px solid #000; margin: 3px 0; }
    .sep-dashed { border: 0; border-top: 1px dashed #000; margin: 3px 0; }
    .num-venta { font-size: 16px; font-weight: 800; text-align: center; margin: 2px 0; -webkit-text-stroke: 0.5px #000; text-shadow: 0.5px 0 0 #000; }
    .info-row { display: flex; justify-content: space-between; font-size: 10px; gap: 6px; }
    .info-row span:first-child { font-weight: 700; -webkit-text-stroke: 0.3px #000; text-shadow: 0.3px 0 0 #000; }
    table { width: 100%; border-collapse: collapse; }
    thead th {
      font-size: 10px;
      text-align: left;
      border-top: 1px solid #000;
      border-bottom: 1px solid #000;
      padding: 2px 2px;
    }
    tbody td {
      font-size: 10px;
      padding: 2px 2px;
      vertical-align: top;
      border-bottom: 1px dashed #ccc;
    }
    tbody tr:last-child td { border-bottom: 1px solid #000; }
    .td-right { text-align: right; }
    .td-left  { text-align: left; }
    .totals { margin-top: 4px; font-size: 11px; }
    .totals .t-row { display: flex; justify-content: space-between; padding: 1px 0; }
    .totals .t-row.grande {
      font-size: 13px;
      font-weight: 800;
      border-top: 1px solid #000;
      margin-top: 2px;
      padding-top: 2px;
      -webkit-text-stroke: 0.4px #000;
      text-shadow: 0.4px 0 0 #000;
    }
    .firma { margin-top: 10mm; border-top: 1px solid #000; text-align: center; font-size: 10px; padding-top: 2px; }
  </style>
</head>
<body>
  <div class="ticket">

    <div class="center" style="margin-bottom:4px;">
      <img src="/tajima.png" alt="TAJIMA" style="width:30mm; height:auto; display:block; margin:0 auto;" />
    </div>

    <div class="empresa-nombre">BYATAJIMATEX</div>
    <div class="empresa-sub">
      BORDADOS COMPUTARIZADOS<br/>
      Y APLICACIONES<br/>
      Av. Juan Pablo II Ceja<br/>
      (El Alto lado Tránsito - Bolivia)<br/>
      Cel.: 75866135 · 75274747 · 77221750<br/>
      byatajima@gmail.com
    </div>

    <hr class="sep-solid"/>

    <div class="center bold" style="font-size:11px; margin-bottom:1px;">VENTA</div>
    <div class="num-venta">N° ${safe(String(o.order_id ?? "--").padStart(6, "0"))}</div>

    <hr class="sep-dashed"/>

    <div class="info-row"><span>Fecha:</span><span> ${moment(o.due_date).format("YYYY-MM-DD")}</span></div>

    <hr class="sep-dashed"/>

    <div class="info-row"><span>Referencia:</span><span class="wrap">${safe(o.order_ref || "-")}</span></div>
    <div class="info-row"><span>Cliente:</span><span class="wrap">${safe(o.customer_name || "-")}</span></div>

    <hr class="sep-solid"/>

    

    <table>
      <thead>
        <tr>
          <th style="width:15px;" class="td-left">Cant</th>
          <th class="td-left">Detalle</th>
          <th style="width:40px;" class="td-right">P/U</th>
          <th style="width:40px;" class="td-right">Total</th>
        </tr>
      </thead>
      <tbody>
        ${filas || `<tr><td colspan="4" class="td-left" style="padding:4px;">(Sin ítems)</td></tr>`}
      </tbody>
    </table>

    <div class="totals">
      <div class="t-row"><span>Subtotal:</span><span>${money(subtotal)}</span></div>
      <div class="t-row"><span>Impuesto:</span><span>${toNumber(o.tax)}%</span></div>
      <div class="t-row"><span>Descuento:</span><span>${money(o.descuento ?? 0)}</span></div>
      <div class="t-row grande"><span>TOTAL:</span><span>${money(o.grand_total)}</span></div>
    </div>

    <div class="firma">Firma / Sello</div>
  </div>

  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() { window.close(); };
    };
  </script>
</body>
</html>
  `;

    const w = window.open("", "_blank", "width=400,height=600");
    if (!w) {
      swal("Bloqueado", "Tu navegador bloqueó la ventana de impresión. Permite pop-ups.", "warning");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  };

// FIN IMPRESION TERMICA

  const imprimirVentasFiltradas = async () => {
    const result = await fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/get_orders`, {
      method: "POST",
      headers: { "Content-type": "application/json; charset=UTF-8" },
      credentials: "include",
      body: JSON.stringify({
        start_value: 0,
        sort_column: sortColumn,
        sort_order: sortOrder,
        search_value: searchInput,
        date_from: dateFrom || null,
        date_to: dateTo || null,
        export_all: true,
      }),
    });

    const body = await result.json();
    const rows = body.info?.orders || [];

    const safe = (s) =>
      String(s ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    const filas = rows.map((o, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${safe(o.order_ref || "")}</td>
      <td>${safe(o.customer_name || "")}</td>
      <td>${o.due_date ? moment(o.due_date).format("YYYY-MM-DD") : ""}</td>
      <td style="text-align:right;">${money(o.grand_total)}</td>
      <td>${o.timeStamp ? moment(o.timeStamp).format("YYYY-MM-DD") : ""}</td>
    </tr>
  `).join("");

    const totalSum = rows.reduce((acc, o) => acc + toNumber(o.grand_total), 0);

    const html = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>Historial de Ventas</title>

  <style>
    @page { size: letter portrait; margin: 0; }
    body { margin: 0; font-family: Arial, sans-serif; color: #111; }

    .page {
      width: 8.5in;
      height: 11in;
      padding: 0.45in;
      box-sizing: border-box;
    }

    .header{
      display: grid;
      grid-template-columns: 230px 1fr 170px;
      column-gap: 28px;
      align-items: start;
    }

    .col-center { text-align: center; }
    .logo { width: 180px; margin-bottom: 6px; }

    .small { font-size: 11px; line-height: 1.3; }
    .muted { color:#444; }
    .title { font-size: 18px; font-weight: 700; }

    .rightBox{
      display: flex;
      flex-direction: column;
      gap: 2px;
      font-size: 11px;
    }

    .rline{
      display: flex;
      gap: 8px;
    }

    .lbl{ min-width: 54px; font-weight: 700; }
    .val{ font-weight: 400; }

    hr.sep{
      border: 0;
      border-top: 1px solid #000;
      margin: 8px 0;
    }

    .meta{
      font-size: 12px;
      font-weight: 600;
      border-bottom: 1px solid #000;
      padding-bottom: 4px;
      margin-bottom: 6px;
    }

    table{
      width:100%;
      border-collapse: collapse;
      margin-top: 6px;
    }

    th,td{
      border-bottom:1px solid #ccc;
      padding:6px;
      font-size:12px;
    }

    th{
      border-top:2px solid #000;
      border-bottom:2px solid #000;
    }

    .c-center{text-align:center}
    .c-right{text-align:right}
    .c-left{text-align:left}

    .totals{
      margin-top: 10px;
      font-size: 12px;
      font-weight: 700;
      display:flex;
      justify-content: space-between;
      border-top:2px solid #000;
      padding-top:6px;
    }
  </style>
</head>

<body>
  <div class="page">

    <!-- HEADER -->
    <div class="header">
      <div>
        <img class="logo" src="/tajima.png" />
        <div class="small">
          <div><b>BORDADOS COMPUTARIZADOS</b></div>
          <div>Y APLICACIONES TAJIMA TEXTIL</div>
          <div class="muted">E-mail: byatajima@gmail.com</div>
          <div class="muted">jhonnfya@hotmail.com</div>
        </div>
      </div>

      <div class="col-center">
        <div class="title">HISTORIAL DE VENTAS</div>
        <div class="small" style="margin-top:6px;">
          <div><b>Dir.:</b> Av. Juan Pablo II Ceja</div>
          <div>(El Alto lado Tránsito - Bolivia)</div>
          <div>Cel.: 75866135 - 75274747 - 77221750</div>
        </div>
      </div>

      <div>
        <div class="rightBox">
          <div class="rline">
            <span class="lbl">Fecha:</span>
            <span class="val">${moment().format("YYYY-MM-DD")}</span>
          </div>
          <div class="rline">
            <span class="lbl">Hora:</span>
            <span class="val">${moment().format("HH:mm:ss")}</span>
          </div>
        </div>
      </div>
    </div>

    <hr class="sep"/>

    <div class="meta">
      <div>Del ${dateFrom || "—"} al ${dateTo || "—"}</div>
      <div>Filas: <b>${rows.length}</b></div>
    </div>

    <table>
      <thead>
        <tr>
          <th class="c-center">#</th>
          <th class="c-center">Ref</th>
          <th class="c-left">Cliente</th>
          <th class="c-center">Vence</th>
          <th class="c-right">Total</th>
          <th class="c-center">Fecha</th>
        </tr>
      </thead>
      <tbody>
        ${filas || `<tr><td colspan="6">Sin datos</td></tr>`}
      </tbody>
    </table>

    <div class="totals">
      <div>TOTAL VENTAS: ${rows.length}</div>
      <div>MONTO TOTAL: ${money(totalSum)}</div>
    </div>

  </div>

  <script>
    window.onload = function(){
      window.print();
      window.onafterprint = function(){ window.close(); }
    }
  </script>
</body>
</html>
`;


    const w = window.open("", "_blank", "width=900,height=650");
    if (!w) {
      swal("Bloqueado", "Tu navegador bloqueó la ventana de impresión. Permite pop-ups.", "warning");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  return (
    <div className='orders'>
      <div style={{ overflow: "scroll", height: "100%" }} >
        <div className="order-header">

          {/* ===== FILTROS (PRIMERA FILA) ===== */}
          <div className="filters-bar">
            <div className="filters-left">

              <label>
                <span>Desde:</span>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </label>

              <label>
                <span>Hasta:</span>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </label>

              <button
                className="btn primary"
                onClick={() => {
                  setFilterFrom(dateFrom || null);
                  setFilterTo(dateTo || null);
                  setTablePage(1);
                  getOrders(0, sortColumn, sortOrder, searchInput);
                }}
              >
                Filtrar
              </button>


              <button
                className="btn warning"
                onClick={imprimirVentasFiltradas}
              >
                Imprimir reporte
              </button>

            </div>
          </div>

          {/* ===== TITULO + BOTON (SEGUNDA FILA) ===== */}
          <div className="title-row">
            <div className="title">Ventas</div>

            <Link
              to={"/orders/addnew"}
              className="btn success"
              style={{ textDecoration: "none" }}
            >
              Agregar nuevo
            </Link>
          </div>

        </div>


        {
          pageState === 1 ? <Loader /> :
            pageState === 2 ?
              <div className="card">
                <div className="container">
                  <Table
                    headers={['N°', 'Ref. Pedido', 'Cliente', 'Vence', 'Total', 'Fecha', 'Acción']}
                    columnOriginalNames={["order_ref", "customer_name", "due_date", "grand_total", "timeStamp"]}
                    sortColumn={sortColumn}
                    setSortColumn={setSortColumn}
                    sortOrder={sortOrder}
                    setSortOrder={setSortOrder}
                    data={data}
                    data_count={orderCount}
                    searchInput={searchInput}
                    setSearchInput={setSearchInput}
                    custom_styles={["3rem", "6rem", "6rem", "8rem", "5rem", "8rem", "10rem"]}
                    current_page={tablePage}
                    tablePageChangeFunc={setTablePage}
                  />
                </div>
              </div>
              :
              <Error />
        }

        <Modal show={viewModalShow} onHide={handleViewModalClose} size="lg" centered >

          <Modal.Header>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
              <Modal.Title className='fs-4 fw-bold' style={{ color: "#2cd498" }}>
                Ver pedido
              </Modal.Title>

              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <button className="btn-close" onClick={handleViewModalClose}></button>
              </div>
            </div>
          </Modal.Header>


          <Modal.Body style={{ backgroundColor: "#fafafa" }} >
            <div className='container d-flex gap-2'>
              <div className='card my_card' style={{ flex: 1 }}>
                <div className='card-body'>
                  {
                    viewOrderDetails &&
                    <>
                      <div className='form-group mb-2'>
                        <label className='fw-bold'>Referencia</label>
                        <input className='my_form_control' value={viewOrderDetails.order_ref} readOnly />
                      </div>
                      <div className='form-group mb-2'>
                        <label className='fw-bold'>Cliente</label>
                        <input className='my_form_control' value={viewOrderDetails.customer_name} readOnly />
                      </div>
                      <div className='form-group mb-2'>
                        <label className='fw-bold'>Fecha de vencimiento</label>
                        <input className='my_form_control' value={moment(viewOrderDetails.due_date).format('D [de] MMMM, YYYY')} readOnly />
                      </div>
                      <div className='form-group mb-2'>
                        <label className='fw-bold'>Impuesto</label>
                        <input className='my_form_control' value={`${viewOrderDetails.tax}%`} readOnly />
                      </div>
                       <div className='form-group mb-2'>
                        <label className='fw-bold'>Descuento</label>
                        <input className='my_form_control' value={viewOrderDetails.descuento} readOnly />
                      </div>
                      <div className='form-group mb-2'>
                        <label className='fw-bold'>Total</label>
                        <input className='my_form_control' value={viewOrderDetails.grand_total} readOnly />
                      </div>

                      <div className='form-group mb-2'>
                        <label className='fw-bold mb-2'>Detalle de productos</label>
                        <div className='p-2 border rounded'>
                          <div className='mb-2 row gx-0 fw-bold text-secondary' style={{ fontSize: "smaller" }}>
                            <div className='col-6'>Producto</div>
                            <div className='col-2 text-center'>Cantidad</div>
                            <div className='col-2 text-center'>Precio</div>
                            <div className='col-2 text-center'>Total</div>
                          </div>

                          {
                            viewOrderDetails.items &&
                            JSON.parse(viewOrderDetails.items).map((viewItem, ind) => (
                              <div key={ind} className='py-2 row gx-0' style={{ borderBottom: "1px dashed lightgray" }}>
                                <div className='col-6'>{viewItem.product_name}</div>
                                <div className='col-2 text-center'>{viewItem.quantity}</div>
                                <div className='col-2 text-center'>{viewItem.rate}</div>
                                <div className='col-2 text-center'>{viewItem.rate * viewItem.quantity}</div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </>
                  }
                </div>
              </div>
            </div>
          </Modal.Body>



          <Modal.Footer className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-outline-primary"
              onClick={() => imprimirVenta(viewOrderDetails)}
              disabled={!viewOrderDetails}
            >
              Imprimir
            </button>

            <button
              className="btn btn-outline-primary"
              onClick={() => imprimirVentaTermica(viewOrderDetails)}
              disabled={!viewOrderDetails}
            >
              Impresion termica
            </button>

            <button className='btn btn-outline-danger' onClick={handleViewModalClose}>
              Cerrar
            </button>
          </Modal.Footer>

        </Modal>
      </div>
    </div>
  )
}

export default Orders
